import { Form } from 'antd';
import React from 'react';
import DropdownSelect from '../../../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';

const Address = ({ streetConfig, houseConfig, addressConfig }) => {
  return (
    <div>
      <Form.Item
        label="Улица"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          value={streetConfig.value}
          onChange={streetConfig.onChange}
          multiple={false}
          options={streetConfig.data}
          renderControl={getRenderControl({
            options: streetConfig.data,
            isClear: true,
            onClearClick: () => {
              streetConfig.onChange(null);
            },
            value: streetConfig.value,
            placeholder: 'Выберите из списка',
            disabled: streetConfig.isLoading,
            loading: streetConfig.isLoading,
          })}
        />
      </Form.Item>
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <Form.Item
          label="Дом"
          style={{ margin: 0, flex: 1 }}
        >
          <DropdownSelect
            value={houseConfig.value}
            onChange={houseConfig.onChange}
            multiple={false}
            options={houseConfig.data}
            renderControl={getRenderControl({
              options: houseConfig.data,
              isClear: true,
              onClearClick: () => {
                houseConfig.onChange(null);
              },
              value: houseConfig.value,
              placeholder: '№',
              disabled: houseConfig.isLoading,
              loading: houseConfig.isLoading,
            })}
          />
        </Form.Item>
        <Form.Item
          label="Кв./офис"
          style={{ margin: 0, flex: 1 }}
        >
          <DropdownSelect
            value={addressConfig.value}
            onChange={addressConfig.onChange}
            disabled={addressConfig.isLoading}
            loading={addressConfig.isLoading}
            multiple={true}
            options={addressConfig.data}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default Address;
